import { Injectable, inject } from '@angular/core';

import { PriceBoostConfig } from '@frontend/sports/common/client-config-data-access';

import { SignpostType } from '../signpost.model';

@Injectable({ providedIn: 'root' })
export class SignpostTypeService {
    private priceBoostConfig = inject(PriceBoostConfig);

    signpostType = SignpostType.None;

    get isPriceBoost(): boolean {
        return (this.priceBoostConfig.isEnabled || this.priceBoostConfig.isEnabledAPB) && this.signpostType === SignpostType.PriceBoost;
    }
}
